<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px" class="approveForm">
                <el-row>
                    <el-form-item label="会员地址">
                        <el-input v-model="params.memberAddress" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="资产类型">
                        <el-select v-model="params.currency" clearable>
                            <el-option label="USDT" value="USDT"></el-option>
                            <el-option label="ALD" value="ALD"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
        </div>
        <el-table border :data="tableData" id="out-table" class="table-show-current" highlight-current-row>
            <el-table-column prop="mid" align="center" label="会员UID" width="100"></el-table-column>
            <el-table-column align="center" label="会员地址" width="150" class-name="address">
                <template slot-scope="scope" v-if="scope.row.memberAddress">
                    <span  v-clipboard:copy="scope.row.memberAddress" v-clipboard:success="onCopy">
                        {{showAddress(scope.row.memberAddress)}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="currency" align="center" label="资产类型"></el-table-column>
            <el-table-column prop="useable" align="center" label="可用余额"></el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" align="center" width="150"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { assetsApi } from '@/api/api-assets';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
export default {
    data() {
        return {
            tableData: [],
            total: 0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            params: {},
        };
    },
    created() {
        this.handleSearch();
    },
    methods: {
        onCopy() {
            this.$message.success({message: "复制成功",duration: 600})
        },
        handleSearch() {
            assetsApi.findDataPageList(this.params, this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        exportExcel() {
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['会员UID','会员地址','可用余额',"更新时间"];
            let columns = ['id', 'memberAddress','useable','updatedAt'];
            let data = this.tableData.map(r => columns.map(c => {
                let val = r[c];
                return val; 
            }));
            exportData2(header,data,"资产数据");
        }
    }
};
</script>
